import { Clock3, LogOut, ShieldCheck } from 'lucide-react'
import { Button } from '../components/Ui'
import { useAuth } from '../state/auth'

export function AccessPendingPage() {
  const { access, signOut } = useAuth()
  const whatsapp = import.meta.env.VITE_SALES_WHATSAPP?.replace(/\D/g, '') ?? ''
  const expired = access?.status === 'active' && !access.allowed
  const suspended = access?.status === 'suspended'
  const title = expired ? 'Masa akses telah berakhir' : suspended ? 'Akses akun dihentikan' : 'Aktivasi akun diperlukan'
  const description = expired
    ? 'Perpanjang akses agar kamu bisa kembali membuka catatan keuanganmu.'
    : suspended
      ? 'Hubungi pengelola untuk memeriksa status akun ini.'
      : 'Akunmu sudah dibuat. Akses aplikasi aktif setelah pembayaran diverifikasi oleh pengelola.'
  const message = encodeURIComponent('Halo admin Dhuwit, saya ingin mengaktifkan akses akun saya.')
  const contactHref = whatsapp ? `https://wa.me/${whatsapp}?text=${message}` : 'mailto:apabaetone@gmail.com?subject=Aktivasi%20akun%20Dhuwit'

  return <main className="access-page">
    <section className="access-panel">
      <span className="access-panel__icon"><ShieldCheck size={25} aria-hidden="true" /></span>
      <span className="eyebrow">Status akses Dhuwit</span>
      <h1>{title}</h1>
      <p>{description}</p>
      <div className="access-panel__status"><Clock3 size={17} aria-hidden="true" /><span><strong>Status akun</strong><small>{access?.status === 'active' ? 'Menunggu perpanjangan' : access?.status === 'suspended' ? 'Perlu pemeriksaan' : 'Menunggu aktivasi'}</small></span></div>
      <div className="access-panel__actions">
        <a className="button button--primary" href={contactHref} target={whatsapp ? '_blank' : undefined} rel={whatsapp ? 'noreferrer' : undefined}>{whatsapp ? 'Hubungi admin via WhatsApp' : 'Hubungi pengelola'}</a>
        <Button variant="ghost" onClick={() => void signOut()}><LogOut size={16} aria-hidden="true" />Keluar</Button>
      </div>
      <small>Data akun tetap tersimpan dan tidak dapat dibuka akun lain.</small>
    </section>
  </main>
}
